<template>
    <div>
        <v-container grid-list-md>
            <v-layout row wrap>
                <v-flex xs12 sm6 md3 v-for="(product, index) in products" :key="product.name">
                    <div style="display: flex; align-content: space-around;"></div>
                    <v-card style="height: auto; position: relative;" >
                        <v-fade-transition origin="top center 0">
                            <v-icon v-if="shows[index].add" x-large color="primary" style="position: absolute; left: 45%; top: 45%; z-index: 1;">
                                fas fa-plus
                            </v-icon>
                        </v-fade-transition>
                        <v-fade-transition origin="top center 0">
                            <v-icon v-if="shows[index].minus" x-large color="error" style="position: absolute; left: 45%; top: 45%; z-index: 1;">
                                fas fa-minus
                            </v-icon>
                        </v-fade-transition>
                        <div  style="height: 80px;">
                            <v-card-title primary-title class="ma-0 pb-2 pt-2">
                                <div>
                                    <span class="grey--text body-1">{{product.descricao}}</span>
                                    <p class="title ma-0">{{product.nome}}</p> 
                                </div>
                            </v-card-title>
                        </div>
                        <div style="height: 255px;">
                            <v-carousel style="height: 200px !important;" :cycle="false" class="elevation-0"
                             flat light hide-controls hide-delimiters interval="100000">
                                <v-carousel-item v-for="(qtd, i) in product.imgQtd" :key="i">
                                    <img style="height: 200px !important;" :src="getImgSVG(product.img + '-' + (i + 1))" alt="">
                                    
                                </v-carousel-item>
                            </v-carousel>

                            <v-card-actions style="position: relative; botton: 0; height: 55px;">
                                <p class="subheading font-weight-black" style="margin: 10px;">{{'R$ ' + product.preco}}</p>
                                <v-spacer></v-spacer>

                                <v-btn flat icon color="primary" class="ma-0" @click="addItem(index)">
                                    <v-icon >fas fa-plus-circle</v-icon>
                                </v-btn>

                                <v-btn flat icon color="error" class="ma-0" @click="removeItem(index)">
                                    <v-icon>fas fa-minus-circle</v-icon>
                                </v-btn>
                                
                                <v-btn class="ma-0" icon @click="shows[index].show = !shows[index].show">
                                    <v-icon>{{ shows[index].show ? 'fas fa-arrow-alt-circle-up' : 'fas fa-arrow-alt-circle-down' }}</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </div>
                        <v-slide-y-transition>
                            <v-card-text v-show="shows[index].show">
                                {{product.sobre}}
                            </v-card-text>
                        </v-slide-y-transition>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                shows: [],
                products: this.$store.state.products.arduino,
                add: false,
                minus: false
            }
        },
        methods: {
            getImgSVG(path) {
                let images = require.context('../../assets/produtos/', false, /\.svg$/)
                return images('./' + path + '.svg')
            },
            addItem(index) {
                var aux = this.$store.state
                var flag = 0
                
                for(let i = 0; i < aux.carrinho.length; i++){
                    if(aux.products.arduino[index].nome == aux.carrinho[i].nome){
                        aux.carrinho[i].qtdCarrinho++
                        flag++
                    }
                }

                if(!flag){
                    aux.carrinho.push(aux.products.arduino[index])
                }

                aux.soma += aux.products.arduino[index].preco

                this.shows[index].add = true
                setTimeout(() => (this.shows[index].add = false), 500)
            },
            removeItem(index){
                var aux = this.$store.state
                var flag = 0
                
                for(let i = 0; i < aux.carrinho.length; i++){
                    if(aux.products.arduino[index].nome === aux.carrinho[i].nome){
                        if(aux.carrinho[i].qtdCarrinho > 1){
                            aux.carrinho[i].qtdCarrinho--
                        } else {
                            aux.carrinho.splice(i, 1)
                        }
                        if(aux.soma > 0) aux.soma -= aux.products.arduino[index].preco
                    }
                }   
                
                this.shows[index].minus = true
                setTimeout(() => (this.shows[index].minus = false), 500)
            }
        },
        created() {
            for(let i = 0; i < this.$store.state.products.arduino.length; i++){
                this.shows.push({show: false, add: false, minus: false})
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/categorias/arduino.vue